import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { Material } from "./material";
const BrandReceipts = types.model({
  brand: types.maybeNull(types.string),
  totalStock: types.maybeNull(types.number),
});
const BrandGroup = types.model({
  brand: types.maybeNull(types.string),
  totalIssueStock: types.maybeNull(types.number),
  totalReceiptStock: types.maybeNull(types.number),
  totalStock: types.maybeNull(types.number),
});
export const MaterialInventory = types.model({
  materialId: types.maybeNull(types.string),
  material: types.maybeNull(Material),
  stock: types.maybeNull(types.number),
  totalIssueStock: types.maybeNull(types.number),
  totalReceiptStock: types.maybeNull(types.number),
  receiptGroupedItems: types.maybeNull(types.array(BrandReceipts)),
  groupedItems: types.maybeNull(types.array(BrandGroup)),
});

export interface IMaterialInventory extends Instance<
  typeof MaterialInventory
> {}
export interface IMaterialInventoryProperties extends SnapshotIn<
  typeof MaterialInventory
> {}
